import { authFetch } from 'src/auth/utils';
import { ChartTypeValue } from 'src/common/components/ChartTypeToggle/ChartTypeToggle';
import { PeriodTypeValue } from 'src/common/components/PeriodTypeSwitch/PeriodTypeSwitch';
import { UsageTypeValue } from 'src/common/components/UsageTypeSwitch/UsageTypeSwitch';
import { envVariables } from 'src/common/utils/envVariables';
import { UsageDto } from 'src/common/utils/mapUsageDTOtoAreaChartData';

type GetRsimUsageDataProps = {
  accountRef: string;
  periodType: PeriodTypeValue;
};

type PerformanceDTO = {
  data: PerformanceData[];
};

export type PerformanceData = {
  label: string;
  value: {
    primary: number;
    backup: number;
    switched: number;
    disconnected: number;
  };
};

export const getRsimPerformanceData = async (
  { accountRef, periodType }: GetRsimUsageDataProps,
  signal?: AbortSignal,
) => {
  const tariffSummaryCumulativeUsageResponse = await authFetch(
    `${envVariables.VITE_ANALYTICS_MODULE_URL}/inventory/rsims-performance?accountRef=${accountRef}&period=${periodType}`,
    {
      signal,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  const rsimPerformanceDataDTO: PerformanceDTO = await tariffSummaryCumulativeUsageResponse.json();

  return rsimPerformanceDataDTO.data;
};

type GetRSimUsageDataProps = {
  accountRef: string;
  chartType: ChartTypeValue;
  usageType: UsageTypeValue;
};

export const getRSimUsageData = async (
  { accountRef, chartType, usageType }: GetRSimUsageDataProps,
  signal?: AbortSignal,
) => {
  const rsimUsageUsageResponse = await authFetch(
    `${envVariables.VITE_ANALYTICS_MODULE_URL}/usage-tracking/tariff-usage/rsims/${accountRef}/daily/${chartType}/${usageType}/linechart`,
    {
      signal,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  const rsimUsageUsageDTO: UsageDto = await rsimUsageUsageResponse.json();

  return rsimUsageUsageDTO.chartData;
};
